export enum BarMenuItemTagType {
    Success = 'success',
    Warning = 'warning',
    Error = 'error',
    Info = 'info',
    Default = 'default'
}
